import Vue from 'vue';
import VueMatomo from 'vue-matomo';
import { router } from '@/router';

if (window.QRP_MATOMO_ENABLED === 'true') {
	Vue.use(VueMatomo, {
		host: window.QRP_MATOMO_URL,
		siteId: window.QRP_MATOMO_SITE_ID,
		trackerFileName: 'matomo',
		router
	});
}
